// ** React Imports
import { exact } from 'prop-types'
import { lazy } from 'react'

const SpecialOrdersCarsList = lazy(() => import('views/ordering/special-orders/cars/list'))
const SpecialOrdersCarsView = lazy(() => import('views/ordering/special-orders/cars/view'))

const SpecialOrdersBoxesList = lazy(() => import('views/ordering/special-orders/boxes/list'))
const SpecialOrdersBoxesView = lazy(() => import('views/ordering/special-orders/boxes/view'))

const OrderCalendar = lazy(() => import('views/ordering/calendar'))
const OrderList = lazy(() => import('views/ordering/orders/list'))
const OrderAdd = lazy(() => import('views/ordering/orders/add'))
const OrderView = lazy(() => import('views/ordering/orders/view'))
const OrderEdit = lazy(() => import('views/ordering/orders/edit'))
const InvoiceAdd = lazy(() => import('views/financial/invoices/add'))
const PaymentAdd = lazy(() => import('views/financial/payments/add'))

const ChinesCarsList = lazy(() => import('views/ordering/chines-orders/cars/list'))
const ChinesCarsView = lazy(() => import('views/ordering/chines-orders/cars/view'))

const OrderingRoutes = [
  {
    element: <ChinesCarsView />,
    path: '/chines-cars/:id/view',
    meta: { resource: 'special_orders', action: 'read', className: 'ecommerce-application' }
  },
  {
    element: <ChinesCarsList />,
    path: '/chines-cars',
    meta: { resource: 'special_orders', action: 'read' }
  },
  {
    element: <OrderCalendar />,
    path: '/calendar'
  },
  {
    element: <SpecialOrdersCarsView />,
    path: '/special-orders/cars/:id/view',
    meta: {
      className: 'ecommerce-application',
      resource: 'special_orders',
      action: 'read'
    }
  },
  {
  element: <SpecialOrdersCarsList />,
  path: '/special-orders/cars',
  meta: {
    resource: 'special_orders',
    action: 'read'
    },
  },
  {
    element: <SpecialOrdersBoxesView />,
    path: '/special-orders/boxes/:id/view',
    meta: {
      className: 'ecommerce-application',
      resource: 'special_orders',
      action: 'read'
    }
  },
  {
    element: <SpecialOrdersBoxesList />,
    path: '/special-orders/boxes',
    meta: {
      resource: 'special_orders',
      action: 'read'
    }
  },
  {
    element: <OrderAdd />,
    path: '/orders/-/add',
    meta: {
      resource: 'orders',
      action: 'add'
    }
  },
  {
    element: <PaymentAdd />,
    path: '/orders/:orderId/payments/-/add',
    meta: {
      resource: 'payments',
      action: 'add'
    }
  },
  {
    element: <InvoiceAdd />,
    path: '/orders/:orderId/invoices/-/add',
    meta: {
      resource: 'invoices',
      action: 'add'
    }
  },

  {
    element: <OrderView />,
    path: '/orders/:id/view',
    meta: {
      className: 'ecommerce-application',
      resource: 'orders',
      action: 'read'
    }
  },
  {
    element: <OrderEdit />,
    path: '/orders/:id/edit',
    meta: {
      className: 'ecommerce-application',
      resource: 'orders',
      action: 'modify'
    }
  },
  {
    element: <OrderList />,
    path: '/orders',
    meta: {
      resource: 'orders',
      action: 'read'
    }
  },
  {
    element: <OrderList />,
    path: '/archive',
    meta: {
      resource: 'archive',
      action: 'read'
    }
  }
]

export default OrderingRoutes
